import { DynamicExchangeRate, ExtractionStatus, FileTypes, Frequency, SkuFilter, ViewBy } from '..';
import { PricePer } from './types/price-per.type';
import { TimeSeriesData } from './types/time-series-data.type';

export class ExtractionMutated {
    constructor(
        public id: number,
        public title: string,
        public description: string,
        public startDate: Date,
        public endDate: Date,
        public pricePer: PricePer,
        public currency: string,
        public frequency: Frequency,
        public viewBy: ViewBy,
        public dateCreated: Date,
        public timeSeriesData: TimeSeriesData[],
        public includeAttributesFile: boolean,
        public fileType: FileTypes,
        public skuFilters: SkuFilter,
        public status: ExtractionStatus,
        public filterNames: filterNames,
        public skuCount: number,
        public isLoaded: boolean,
        public isDownloading: boolean,
        public searchPhrase?: string,
        public exchangeRates?: DynamicExchangeRate[]
    ) { }
}
export type filterNames = {
    countries: string[];
    categories: string[];
    suppliers: string[];
    brands: string[];
    attributeTypes: string[];
    attributes: string[];
    retailerTypes: string[];
    retailers: string[];
    promotions: string[];
};
